import { jsx as r } from "react/jsx-runtime";
import { forwardRef as n } from "react";
import s from "@mui/material/ListItemSecondaryAction";
import c from "styled-components";
const a = {
  root: "listItemSecondaryActionRoot"
}, m = c(s).withConfig({
  displayName: "StyledListItemSecondaryAction"
})([
  "&&.listItemSecondaryActionRoot{font-size:",
  ";color:currentColor;letter-spacing:normal;line-height:1.2em;}"
], ({ theme: t }) => t.typography.body200.fontSize), d = /* @__PURE__ */ n(({ children: t, classes: o, ...e }, i) => /* @__PURE__ */ r(m, {
  ...e,
  ref: i,
  classes: {
    ...a,
    ...o
  },
  children: t
}));
d.displayName = "ListItemSecondaryAction";
export {
  d as default
};
